import AdminLiveAuditLogPage from '../../../components/admin/audit-log/AdminLiveAuditLogPage'

export default function AuditLog() {
  return <AdminLiveAuditLogPage />
}
